export const countries = [
    { id: "AD", label: "Andorre", phonePrefix: "376" },
    { id: "AE", label: "Émirats arabes unis", phonePrefix: "971" },
    { id: "AF", label: "Afghanistan", phonePrefix: "93" },
    { id: "AG", label: "Antigua-et-Barbuda", phonePrefix: "1 268" },
    { id: "AI", label: "Anguilla", phonePrefix: "1 264" },
    { id: "AL", label: "Albanie", phonePrefix: "355" },
    { id: "AM", label: "Arménie", phonePrefix: "374" },
    { id: "AO", label: "Angola", phonePrefix: "244" },
    { id: "AR", label: "Argentine", phonePrefix: "54" },
    { id: "AS", label: "Samoa américaines", phonePrefix: "1 684" },
    { id: "AT", label: "Autriche", phonePrefix: "43" },
    { id: "AU", label: "Australie", phonePrefix: "61" },
    { id: "AW", label: "Aruba", phonePrefix: "297" },
    { id: "AX", label: "Îles Åland", phonePrefix: "358" },
    { id: "AZ", label: "Azerbaïdjan", phonePrefix: "994" },
    { id: "BA", label: "Bosnie-Herzégovine", phonePrefix: "387" },
    { id: "BB", label: "Barbade", phonePrefix: "1 246" },
    { id: "BD", label: "Bangladesh", phonePrefix: "880" },
    { id: "BE", label: "Belgique", phonePrefix: "32" },
    { id: "BF", label: "Burkina Faso", phonePrefix: "226" },
    { id: "BG", label: "Bulgarie", phonePrefix: "359" },
    { id: "BH", label: "Bahreïn", phonePrefix: "973" },
    { id: "BI", label: "Burundi", phonePrefix: "257" },
    { id: "BJ", label: "Bénin", phonePrefix: "229" },
    { id: "BL", label: "Saint-Barthélemy", phonePrefix: "590" },
    { id: "BM", label: "Bermudes", phonePrefix: "1 441" },
    { id: "BN", label: "Brunei", phonePrefix: "673" },
    { id: "BO", label: "Bolivie", phonePrefix: "591" },
    { id: "BQ", label: "Pays-Bas caribéens", phonePrefix: "599" },
    { id: "BR", label: "Brésil", phonePrefix: "55" },
    { id: "BS", label: "Bahamas", phonePrefix: "1 242" },
    { id: "BT", label: "Bhoutan", phonePrefix: "975" },
    { id: "BW", label: "Botswana", phonePrefix: "267" },
    { id: "BY", label: "Biélorussie", phonePrefix: "375" },
    { id: "BZ", label: "Belize", phonePrefix: "501" },
    { id: "CA", label: "Canada", phonePrefix: "1" },
    { id: "CC", label: "Îles Cocos", phonePrefix: "61" },
    { id: "CD", label: "République démocratique du Congo", phonePrefix: "243" },
    { id: "CF", label: "République centrafricaine", phonePrefix: "236" },
    { id: "CG", label: "Congo", phonePrefix: "242" },
    { id: "CH", label: "Suisse", phonePrefix: "41" },
    { id: "CI", label: "Côte d'Ivoire", phonePrefix: "225" },
    { id: "CK", label: "Îles Cook", phonePrefix: "682" },
    { id: "CL", label: "Chili", phonePrefix: "56" },
    { id: "CM", label: "Cameroun", phonePrefix: "237" },
    { id: "CN", label: "Chine", phonePrefix: "86" },
    { id: "CO", label: "Colombie", phonePrefix: "57" },
    { id: "CR", label: "Costa Rica", phonePrefix: "506" },
    { id: "CU", label: "Cuba", phonePrefix: "53" },
    { id: "CV", label: "Cap-Vert", phonePrefix: "238" },
    { id: "CW", label: "Curaçao", phonePrefix: "599" },
    { id: "CX", label: "Île Christmas", phonePrefix: "61" },
    { id: "CY", label: "Chypre", phonePrefix: "357" },
    { id: "CZ", label: "République tchèque", phonePrefix: "420" },
    { id: "DE", label: "Allemagne", phonePrefix: "49" },
    { id: "DJ", label: "Djibouti", phonePrefix: "253" },
    { id: "DK", label: "Danemark", phonePrefix: "45" },
    { id: "DM", label: "Dominique", phonePrefix: "1 767" },
    { id: "DO", label: "République dominicaine", phonePrefix: "1809 - 1829 - 1849" },
    { id: "DZ", label: "Algérie", phonePrefix: "213" },
    { id: "EC", label: "Équateur", phonePrefix: "593" },
    { id: "EE", label: "Estonie", phonePrefix: "372" },
    { id: "EG", label: "Égypte", phonePrefix: "20" },
    { id: "EH", label: "Sahara occidental", phonePrefix: "212" },
    { id: "ER", label: "Érythrée", phonePrefix: "291" },
    { id: "ES", label: "Espagne", phonePrefix: "34" },
    { id: "ET", label: "Éthiopie", phonePrefix: "251" },
    { id: "FI", label: "Finlande", phonePrefix: "358" },
    { id: "FJ", label: "Fidji", phonePrefix: "679" },
    { id: "FK", label: "Îles Malouines", phonePrefix: "500" },
    { id: "FM", label: "États fédérés de Micronésie", phonePrefix: "691" },
    { id: "FO", label: "Îles Féroé", phonePrefix: "298" },
    { id: "FR", label: "France", phonePrefix: "33" },
    { id: "GA", label: "Gabon", phonePrefix: "241" },
    { id: "GB", label: "Royaume-Uni", phonePrefix: "44" },
    { id: "GD", label: "Grenade", phonePrefix: "1 473" },
    { id: "GE", label: "Géorgie", phonePrefix: "995" },
    { id: "GF", label: "Guyane française", phonePrefix: "594" },
    { id: "GG", label: "Guernesey", phonePrefix: "44" },
    { id: "GH", label: "Ghana", phonePrefix: "233" },
    { id: "GI", label: "Gibraltar", phonePrefix: "350" },
    { id: "GL", label: "Groenland", phonePrefix: "299" },
    { id: "GM", label: "Gambie", phonePrefix: "220" },
    { id: "GN", label: "Guinée", phonePrefix: "224" },
    { id: "GP", label: "Guadeloupe", phonePrefix: "590" },
    { id: "GQ", label: "Guinée équatoriale", phonePrefix: "240" },
    { id: "GR", label: "Grèce", phonePrefix: "30" },
    { id: "GT", label: "Guatemala", phonePrefix: "502" },
    { id: "GU", label: "Guam", phonePrefix: "1 671" },
    { id: "GW", label: "Guinée-Bissau", phonePrefix: "245" },
    { id: "GY", label: "Guyana", phonePrefix: "592" },
    { id: "HK", label: "Hong Kong", phonePrefix: "852" },
    { id: "HN", label: "Honduras", phonePrefix: "504" },
    { id: "HR", label: "Croatie", phonePrefix: "385" },
    { id: "HT", label: "Haïti", phonePrefix: "509" },
    { id: "HU", label: "Hongrie", phonePrefix: "36" },
    { id: "ID", label: "Indonésie", phonePrefix: "62" },
    { id: "IE", label: "Irlande", phonePrefix: "353" },
    { id: "IL", label: "Israël", phonePrefix: "972" },
    { id: "IM", label: "Île de Man", phonePrefix: "44" },
    { id: "IN", label: "Inde", phonePrefix: "91" },
    { id: "IO", label: "Territoire britannique de l'océan Indien", phonePrefix: "246" },
    { id: "IQ", label: "Irak", phonePrefix: "964" },
    { id: "IR", label: "Iran", phonePrefix: "98" },
    { id: "IS", label: "Islande", phonePrefix: "354" },
    { id: "IT", label: "Italie", phonePrefix: "39" },
    { id: "JE", label: "Jersey", phonePrefix: "44" },
    { id: "JM", label: "Jamaïque", phonePrefix: "1 876" },
    { id: "JO", label: "Jordanie", phonePrefix: "962" },
    { id: "JP", label: "Japon", phonePrefix: "81" },
    { id: "KE", label: "Kenya", phonePrefix: "254" },
    { id: "KG", label: "Kirghizistan", phonePrefix: "996" },
    { id: "KH", label: "Cambodge", phonePrefix: "855" },
    { id: "KI", label: "Kiribati", phonePrefix: "686" },
    { id: "KM", label: "Comores", phonePrefix: "269" },
    { id: "KN", label: "Saint-Christophe-et-Niévès", phonePrefix: "1 869" },
    { id: "KP", label: "Corée du Nord", phonePrefix: "850" },
    { id: "KR", label: "Corée du Sud", phonePrefix: "82" },
    { id: "KW", label: "Koweït", phonePrefix: "965" },
    { id: "KY", label: "Îles Caïmans", phonePrefix: "1 345" },
    { id: "KZ", label: "Kazakhstan", phonePrefix: "7" },
    { id: "LA", label: "Laos", phonePrefix: "856" },
    { id: "LB", label: "Liban", phonePrefix: "961" },
    { id: "LC", label: "Sainte-Lucie", phonePrefix: "1 758" },
    { id: "LI", label: "Liechtenstein", phonePrefix: "423" },
    { id: "LK", label: "Sri Lanka", phonePrefix: "94" },
    { id: "LR", label: "Liberia", phonePrefix: "231" },
    { id: "LS", label: "Lesotho", phonePrefix: "266" },
    { id: "LT", label: "Lituanie", phonePrefix: "370" },
    { id: "LU", label: "Luxembourg", phonePrefix: "352" },
    { id: "LV", label: "Lettonie", phonePrefix: "371" },
    { id: "LY", label: "Libye", phonePrefix: "218" },
    { id: "MA", label: "Maroc", phonePrefix: "212" },
    { id: "MC", label: "Monaco", phonePrefix: "377" },
    { id: "MD", label: "Moldavie", phonePrefix: "373" },
    { id: "ME", label: "Monténégro", phonePrefix: "382" },
    { id: "MF", label: "Saint-Martin", phonePrefix: "590" },
    { id: "MG", label: "Madagascar", phonePrefix: "261" },
    { id: "MH", label: "Îles Marshall", phonePrefix: "692" },
    { id: "MK", label: "Macédoine du Nord", phonePrefix: "389" },
    { id: "ML", label: "Mali", phonePrefix: "223" },
    { id: "MM", label: "Myanmar", phonePrefix: "95" },
    { id: "MN", label: "Mongolie", phonePrefix: "976" },
    { id: "MO", label: "Macao", phonePrefix: "853" },
    { id: "MP", label: "Îles Mariannes du Nord", phonePrefix: "1 670" },
    { id: "MQ", label: "Martinique", phonePrefix: "596" },
    { id: "MR", label: "Mauritanie", phonePrefix: "222" },
    { id: "MS", label: "Montserrat", phonePrefix: "1 664" },
    { id: "MT", label: "Malte", phonePrefix: "356" },
    { id: "MU", label: "Maurice", phonePrefix: "230" },
    { id: "MV", label: "Maldives", phonePrefix: "960" },
    { id: "MW", label: "Malawi", phonePrefix: "265" },
    { id: "MX", label: "Mexique", phonePrefix: "52" },
    { id: "MY", label: "Malaisie", phonePrefix: "60" },
    { id: "MZ", label: "Mozambique", phonePrefix: "258" },
    { id: "NA", label: "Namibie", phonePrefix: "264" },
    { id: "NC", label: "Nouvelle-Calédonie", phonePrefix: "687" },
    { id: "NE", label: "Niger", phonePrefix: "227" },
    { id: "NF", label: "Île Norfolk", phonePrefix: "672" },
    { id: "NG", label: "Nigéria", phonePrefix: "234" },
    { id: "NI", label: "Nicaragua", phonePrefix: "505" },
    { id: "NL", label: "Pays-Bas", phonePrefix: "31" },
    { id: "NO", label: "Norvège", phonePrefix: "47" },
    { id: "NP", label: "Népal", phonePrefix: "977" },
    { id: "NR", label: "Nauru", phonePrefix: "674" },
    { id: "NU", label: "Niue", phonePrefix: "683" },
    { id: "NZ", label: "Nouvelle-Zélande", phonePrefix: "64" },
    { id: "OM", label: "Oman", phonePrefix: "968" },
    { id: "PA", label: "Panama", phonePrefix: "507" },
    { id: "PE", label: "Pérou", phonePrefix: "51" },
    { id: "PF", label: "Polynésie française", phonePrefix: "689" },
    { id: "PG", label: "Papouasie-Nouvelle-Guinée", phonePrefix: "675" },
    { id: "PH", label: "Philippines", phonePrefix: "63" },
    { id: "PK", label: "Pakistan", phonePrefix: "92" },
    { id: "PL", label: "Pologne", phonePrefix: "48" },
    { id: "PM", label: "Saint-Pierre-et-Miquelon", phonePrefix: "508" },
    { id: "PR", label: "Porto Rico", phonePrefix: "1787 - 1939" },
    { id: "PS", label: "Palestine", phonePrefix: "970" },
    { id: "PT", label: "Portugal", phonePrefix: "351" },
    { id: "PW", label: "Palaos", phonePrefix: "680" },
    { id: "PY", label: "Paraguay", phonePrefix: "595" },
    { id: "QA", label: "Qatar", phonePrefix: "974" },
    { id: "RE", label: "La Réunion", phonePrefix: "262" },
    { id: "RO", label: "Roumanie", phonePrefix: "40" },
    { id: "RS", label: "Serbie", phonePrefix: "381" },
    { id: "RU", label: "Russie", phonePrefix: "7" },
    { id: "RW", label: "Rwanda", phonePrefix: "250" },
    { id: "SA", label: "Arabie saoudite", phonePrefix: "966" },
    { id: "SB", label: "Îles Salomon", phonePrefix: "677" },
    { id: "SC", label: "Seychelles", phonePrefix: "248" },
    { id: "SD", label: "Soudan", phonePrefix: "249" },
    { id: "SE", label: "Suède", phonePrefix: "46" },
    { id: "SG", label: "Singapour", phonePrefix: "65" },
    { id: "SH", label: "Sainte-Hélène", phonePrefix: "290" },
    { id: "SI", label: "Slovénie", phonePrefix: "386" },
    { id: "SJ", label: "Svalbard et Jan Mayen", phonePrefix: "47" },
    { id: "SK", label: "Slovaquie", phonePrefix: "421" },
    { id: "SL", label: "Sierra Leone", phonePrefix: "232" },
    { id: "SM", label: "Saint-Marin", phonePrefix: "378" },
    { id: "SN", label: "Sénégal", phonePrefix: "221" },
    { id: "SO", label: "Somalie", phonePrefix: "252" },
    { id: "SR", label: "Suriname", phonePrefix: "597" },
    { id: "SS", label: "Soudan du Sud", phonePrefix: "211" },
    { id: "ST", label: "Sao Tomé-et-Principe", phonePrefix: "239" },
    { id: "SV", label: "Salvador", phonePrefix: "503" },
    { id: "SX", label: "Saint-Martin", phonePrefix: "1 721" },
    { id: "SY", label: "Syrie", phonePrefix: "963" },
    { id: "SZ", label: "Eswatini", phonePrefix: "268" },
    { id: "TC", label: "Îles Turques-et-Caïques", phonePrefix: "1 649" },
    { id: "TD", label: "Tchad", phonePrefix: "235" },
    { id: "TF", label: "Terres australes et antarctiques françaises", phonePrefix: "262" },
    { id: "TG", label: "Togo", phonePrefix: "228" },
    { id: "TH", label: "Thaïlande", phonePrefix: "66" },
    { id: "TJ", label: "Tadjikistan", phonePrefix: "992" },
    { id: "TK", label: "Tokelau", phonePrefix: "690" },
    { id: "TL", label: "Timor-Leste", phonePrefix: "670" },
    { id: "TM", label: "Turkménistan", phonePrefix: "993" },
    { id: "TN", label: "Tunisie", phonePrefix: "216" },
    { id: "TO", label: "Tonga", phonePrefix: "676" },
    { id: "TR", label: "Turquie", phonePrefix: "90" },
    { id: "TT", label: "Trinité-et-Tobago", phonePrefix: "1 868" },
    { id: "TV", label: "Tuvalu", phonePrefix: "688" },
    { id: "TW", label: "Taïwan", phonePrefix: "886" },
    { id: "TZ", label: "Tanzanie", phonePrefix: "255" },
    { id: "UA", label: "Ukraine", phonePrefix: "380" },
    { id: "UG", label: "Ouganda", phonePrefix: "256" },
    { id: "UM", label: "Îles mineures éloignées des États-Unis", phonePrefix: "1" },
    { id: "US", label: "États-Unis", phonePrefix: "1" },
    { id: "UY", label: "Uruguay", phonePrefix: "598" },
    { id: "UZ", label: "Ouzbékistan", phonePrefix: "998" },
    { id: "VA", label: "Vatican", phonePrefix: "379" },
    { id: "VC", label: "Saint-Vincent-et-les-Grenadines", phonePrefix: "1 784" },
    { id: "VE", label: "Venezuela", phonePrefix: "58" },
    { id: "VG", label: "Îles Vierges britanniques", phonePrefix: "1 284" },
    { id: "VI", label: "Îles Vierges des États-Unis", phonePrefix: "1 340" },
    { id: "VN", label: "Viêt Nam", phonePrefix: "84" },
    { id: "VU", label: "Vanuatu", phonePrefix: "678" },
    { id: "WF", label: "Wallis-et-Futuna", phonePrefix: "681" },
    { id: "WS", label: "Samoa", phonePrefix: "685" },
    { id: "YE", label: "Yémen", phonePrefix: "967" },
    { id: "YT", label: "Mayotte", phonePrefix: "262" },
    { id: "ZA", label: "Afrique du Sud", phonePrefix: "27" },
    { id: "ZM", label: "Zambie", phonePrefix: "260" },
    { id: "ZW", label: "Zimbabwe", phonePrefix: "263" },
];
